import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    logo: {
        width: 145,
        cursor: 'pointer',
        '@media (max-width: 960px)': {
            width: 32
        }
    }
});
